import { Flex, FormRadioSelection, Text } from '@shared/components';

export const options = [
  { label: 'ถูกต้อง', value: 'CORRECT' },
  { label: 'ไม่ถูกต้อง', value: 'INCORRECT' },
];

export interface ProctoringEkycVerificationChecklistProps {
  disabled?: boolean;
  slotProps?: {
    verificationStatus?: {
      photoClarity: string;
      photoIdentityMatch: string;
      idPhotoClarity: string;
    };
  };
}

export default function ProctoringEkycVerificationChecklist(
  props: ProctoringEkycVerificationChecklistProps,
) {
  const { slotProps, disabled: shouldDisabled } = props;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6), width: '100%' })}>
      <Text
        variant='h4'
        sx={(theme) => ({
          borderLeft: `4px solid ${theme.palette.primary.main}`,
          pl: theme.spacing(4),
        })}
      >
        Verification Checklist
      </Text>
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
        <Flex sx={{ justifyContent: 'space-between', width: '100%' }}>
          <Flex sx={(theme) => ({ gap: theme.spacing(1) })}>
            <Text>
              1. ภาพถ่ายหน้าตรงมีความคมชัด ไม่สวมหมวก ไม่สวมแว่นสีดำ
              อยู่ในที่ที่มีแสงสว่างเพียงพอหรือไม่?
            </Text>
            <Text color='error'>*</Text>
          </Flex>
          <FormRadioSelection
            name='photoClarity'
            defaultValue={slotProps?.verificationStatus?.photoClarity}
            options={options}
            row
            required
            disabled={shouldDisabled}
            sx={(theme) => ({
              '& .MuiButtonBase-root': {
                p: 0,
                pr: theme.spacing(2),
              },
            })}
          />
        </Flex>
        <Flex sx={{ justifyContent: 'space-between', width: '100%' }}>
          <Flex sx={(theme) => ({ gap: theme.spacing(1) })}>
            <Text>
              2. <strong>ภาพถ่ายหน้าตรง</strong>
              และรูปถ่ายหน้าบัตรประชาชนสามารถระบุได้ว่าเป็นบุคคลเดียวกันหรือไม่?
            </Text>
            <Text color='error'>*</Text>
          </Flex>
          <Flex sx={(theme) => ({ gap: theme.spacing(2) })}>
            <FormRadioSelection
              name='photoIdentityMatch'
              options={options}
              defaultValue={slotProps?.verificationStatus?.photoIdentityMatch}
              row
              required
              disabled={shouldDisabled}
              sx={(theme) => ({
                '& .MuiButtonBase-root': {
                  p: 0,
                  pr: theme.spacing(2),
                },
              })}
            />
          </Flex>
        </Flex>
        <Flex sx={{ justifyContent: 'space-between', width: '100%' }}>
          <Flex sx={(theme) => ({ gap: theme.spacing(1) })}>
            <Text>
              3. <strong>รูปถ่ายหน้าบัตร</strong>
              ประชาชนมีความคมชัดสามารถมองเห็นตัวอักษรได้อย่างชัดเจนหรือไม่?
            </Text>
            <Text color='error'>*</Text>
          </Flex>
          <FormRadioSelection
            name='idPhotoClarity'
            options={options}
            defaultValue={slotProps?.verificationStatus?.idPhotoClarity}
            row
            required
            disabled={shouldDisabled}
            sx={(theme) => ({
              '& .MuiButtonBase-root': {
                p: 0,
                pr: theme.spacing(2),
              },
            })}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
